import { useNavigate } from "react-router-dom";


const CloudStackContact = (props: any) => {
    const { Contact } = props;
    const navigate = useNavigate();
    //


    return (
        <div
            className="relative flex min-h-[320px] items-center justify-center bg-cover bg-center bg-no-repeat px-4 py-16 text-white md:min-h-[420px] lg:min-h-[500px]"
            style={{
                backgroundImage: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(https://imagedelivery.net/pN4U1Bz5oPlEGJO_1sM7lw/08647ccf-fbea-45fc-8ccf-59d3ddc56200/high)",
            }}
        >
            <div className="mx-auto flex max-w-4xl flex-col items-center gap-8 text-center">
                <h2
                    data-aos="zoom-in-down"
                    className="font-custom text-2xl font-bold leading-normal md:text-3xl lg:text-[44px]"
                >
                    {Contact?.Title}
                </h2>
                <div className="lg:text-lg md:text-base  font-normal  pt-2  text-center mb-7">
                    {Contact?.Description}
                </div>
                <button
                    data-aos="zoom-out"
                    onClick={() => navigate("/contact-us")}
                    className="rounded-full bg-[#8A8A8A] px-5 py-2 text-xs leading-[21.79px] text-white transition hover:bg-white hover:text-black-75 md:text-base"
                >
                    {Contact?.ButtonText}
                </button>
            </div>
        </div>
    );
};

export default CloudStackContact;
